<template>
    <!--这里设置了选中后的radio样式类,和禁用后的样式类-->
    <label class="ui-radio" :class="{'checked':model == value,'disabled':disabled}">
        <input type="radio" ref="radio" :name="name" :value="value" @click="updateVal" :checked="checked"
               :disabled="disabled">{{title}}
    </label>
</template>

<script>
	export default {
		name: 'ui-radio',//radio组件名称
		model: {//自定义 v-model的 prop和event,这个定义的意思就是使用change事件更新model的值,以此来实时更新v-model的值
			prop: 'model',
			event: 'change'
		},
		props: {
			value: {//radio的value属性
				type: [String, Number],
				require: true
			},
			model: {//这里的model指的是上面定义的v-model的prop
				type: [String, Number],
				require: true
			},
			checked: {//是否默认选中
				type: Boolean,
				default: false
			},
			disabled: {//是否禁用
				type: Boolean,
				default: false
			},
			title: {//是否禁用
				type: String,
				default: ''
			},
			name: {
				type: String,
				default: ''
			}
		},
		mounted: function () {//当dom渲染完成,判断组件是否默认选中
			if (this.checked === true) {

			}

			// this.updateVal();
		},
		methods: {
			updateVal: function () {//当用户点击radio时,触发change事件更新v-model
				this.$emit('change', this.$refs.radio.value);
			}
		},
		watch: {
			checked(val) {

			}
		}
	}
</script>

<style lang="scss" scoped>
    $size: 0.6rem;
    $color: #C3C3C3;
    $checkedColor: red;
    $checkedColor: #FF5F42;

    .ui-radio {
        color: #7d7d7d;
        font-size: 0.35rem;
        align-items: center;
        box-sizing: border-box;
        border-radius: 50%;
        display: inline-flex;
        position: relative;
        &:after {
            background-size: 100% 100%;
            color: white;
            content: '\e665';
            width: $size + 0.05rem;
            height: $size + 0.05rem;
            position: absolute;
            left: 0;
            top: 0;
            /*transition: all .3s ease;*/
            opacity: 0;
            transform: scale(0);
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            font-family: "dmicon" !important;
            font-size: ($size /1.5);
            font-style: normal;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }
        &:before {
            content: '';
            width: $size;
            height: $size;
            display: block;
            border-radius: 50%;
            /*background: url("~@assets/img/app-icon/address_default_address.png")no-repeat;*/
            background-size: 100% 100%;
            /*top: -($size /2);
            left: -($size /2);*/
            position: relative;
            /*transform: scale(0.5);*/
            border: 0.025rem solid $color;
        }
        &.checked {
            &:before {
                /*background: url("~@assets/img/app-icon/address_default_address_select.png")no-repeat;*/
                background-color: $checkedColor;
                background-size: 100% 100%;
                border-color: $checkedColor;
            }
            &::after {
                opacity: 1;
                transform: scale(1) //translateX(0.45rem);
            }
        }
        &.disabled {
            border-color: #ccc;
            &:after {
                background-color: #ccc;
            }
        }
        input[type=radio] {
            opacity: 0;
            margin: 0;
            /*width: ($size + 0.15rem);*/
            width: 0.2rem;
            height: $size;
        }
    }

</style>
